import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const deleteIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M31.8 19.2h.4a3 3 0 013 3v29.2a3 3 0 01-3 3h-.4a3 3 0 01-3-3V22.2a3 3 0 013-3zm9.6 0h.4a3 3 0 013 3v29.2a3 3 0 01-3 3h-.4a3 3 0 01-3-3V22.2a3 3 0 013-3zm-19.2 0h.4a3 3 0 013 3v29.2a3 3 0 01-3 3h-.4a3 3 0 01-3-3V22.2a3 3 0 013-3zM11.716 16v42.667h40.568V16h5.796v48H5.92V16h5.796zM40.502 0c0 2.403 2.336 5.333 5.22 5.333H64v5.334H0V5.333h18.275c2.88 0 5.22-2.93 5.22-5.333h17.007z"/></svg>`
);
